module.exports = __webpack_public_path__ + "img/apple-watch.ecb4d87a.png";